const logoReducer = (logo = "", action) => {
    switch (action.type) {
        case "ADD_LOGO":
            return action.payload;
        default:
            return logo;
    }
};

export default logoReducer;
